import classNames from "classnames";
import { Icon } from 'Components';
import { NavItemConfig } from "../Siderbar.constant";
import { InfoTooltip } from "Pages/Dashboard/components";
import styles from '../Sidebar.module.scss';

type Props = { 
	item: NavItemConfig, 
	isActive: boolean, 
	isOpen: boolean,
	showToolTip?: boolean,
	hasChildren: boolean, 
	onClick: () => void; 
}

const NavItem = ({ item, isActive, isOpen, hasChildren, onClick, showToolTip = false } : Props) => {
	const openItem = hasChildren ? isOpen : false;
	
	return <div className={classNames(styles.navItem, 'menu-item', item.key === "logout" ? "sign-out" : "", { [styles['navItem--active']]: isActive, [styles['menu-item-open']]: openItem })}
		onClick={onClick}>
		<InfoTooltip className={styles.item_tooltip} title={item.label} enabled={showToolTip}>
			<span className={classNames(styles.navItem__icon, { [styles['navItem__label-color']]: openItem })}>
				{item.icon}
			</span>
		</InfoTooltip>
		<span className={classNames(styles.navItem__label, { [styles['navItem__label-color']]: openItem })}>
			{item.label}
		</span>
		{hasChildren && (<Icon type="chevronDown" role="icon" className={classNames(styles.navItem__chevron, { [styles['navItem__chevron--open']]: openItem })} />)}
	</div>
}

export default NavItem;